import { formatDate } from '@travelata-libs/utils';
import Cookies from 'js-cookie';
import getWildcardDomain from '@/shared/lib/getWildcardDomain';
import { DATA_LAYER_MAX_STEP_COOKIE, DATA_LAYER_START_COOKIE, DATA_LAYER_START_FORMAT } from '../config';

export function startDataLayerSession(now: Date): string | null {
  if (Cookies.get(DATA_LAYER_START_COOKIE)) return null;

  const start = formatDate(now, DATA_LAYER_START_FORMAT);
  Cookies.set(DATA_LAYER_START_COOKIE, start);

  return start;
}

export function raiseDataLayerMaxStep(maxStep: number): boolean {
  const savedMaxStep = Cookies.get(DATA_LAYER_MAX_STEP_COOKIE);

  const isRaised = !savedMaxStep || Number(savedMaxStep) < maxStep;

  if (isRaised) {
    Cookies.set(DATA_LAYER_MAX_STEP_COOKIE, String(maxStep), { path: '/', domain: getWildcardDomain() });
  }

  return isRaised;
}
